var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice-pop"},[_c('div',{staticClass:"notice-txt"},[_vm._t("default")],2),_c('div',{staticClass:"close iconfont icon-close",on:{"click":_vm.hide}})])
}
var staticRenderFns = []

export { render, staticRenderFns }